var _path, _path2, _path3, _path4, _path5, _rect, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarePlanInprogressIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 9.5V7.5C2.5 4.5 4.5 2.5 7.5 2.5H17.5C20.5 2.5 22.5 4.5 22.5 7.5V9.5",
    stroke: "#0C80F3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 15.5V17.5C2.5 20.5 4.5 22.5 7.5 22.5H17.5C20.5 22.5 22.5 20.5 22.5 17.5V15.5",
    stroke: "#0C80F3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2002 9.75977L12.5002 12.8298L17.7602 9.77979",
    stroke: "#0C80F3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 18.2693V12.8193",
    stroke: "#0C80F3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2602 6.78957L8.06023 8.5696C7.34023 8.9696 6.74023 9.97959 6.74023 10.8096V14.1996C6.74023 15.0296 7.33023 16.0396 8.06023 16.4396L11.2602 18.2196C11.9402 18.5996 13.0602 18.5996 13.7502 18.2196L16.9502 16.4396C17.6702 16.0396 18.2702 15.0296 18.2702 14.1996V10.8096C18.2702 9.97959 17.6802 8.9696 16.9502 8.5696L13.7502 6.78957C13.0602 6.39957 11.9402 6.39957 11.2602 6.78957Z",
    stroke: "#0C80F3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 14,
    width: 13,
    height: 12,
    rx: 6,
    fill: "#B5DAFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6668 19.9997C26.6668 22.2997 24.8002 24.1663 22.5002 24.1663C20.2002 24.1663 18.3335 22.2997 18.3335 19.9997C18.3335 17.6997 20.2002 15.833 22.5002 15.833C24.8002 15.833 26.6668 17.6997 26.6668 19.9997Z",
    stroke: "#0C80F3",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0457 21.3247L22.754 20.5539C22.529 20.4206 22.3457 20.0997 22.3457 19.8372V18.1289",
    stroke: "#0C80F3",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarePlanInprogressIcon);
export default __webpack_public_path__ + "static/media/care_plan_inprogress_icon.3ac3044ba02a70bbe98068da6b1c3190.svg";
export { ForwardRef as ReactComponent };